<template>
  <div>
    <TableManager @filterChanged="filterChanged"  @paginationChanged="paginationChanged" :options="options"/>
    <Accounts
    ref="Accounts"
    :filter="filter"
    :isShowPayment="true"
    :perPage="perPage"
    :currentPage="currentPage"
    @makeToasts="makeToasts"
    @ClickOnPaymentButton="ClickOnPaymentButton"
    @clickOnAccount="openFullAccountInfo"
    @refreshTable="refreshTable"
    v-model="totalRows"/>
    <TableManagerBottom :totalRows="totalRows" :perPage="perPage" v-model="currentPage" />
    <b-modal ref="refPayment" hide-footer @hidden="isShowPayment = false">
      <modal-title>
        {{ $t('Payment') }}
      </modal-title>
      <Payment
      :accountId="accountId"
      :userId="userId"
      @makeToasts="makeToasts"
      @refreshTable="refreshTable"
      @close="closePayment()"
      @back="closePayment()"/>
    </b-modal>
  </div>
</template>

<script>
import Payment from '@/pages/users/formPayment'
import FormAccount from './detail/main'

import Accounts from '@/components/tables/users/Accounts'
import TableManager from '@/components/tables/TableManager'
import TableManagerBottom from '@/components/tables/TableManagerBottom'

export default {
  components: {
    Accounts,
    Payment,
    TableManager,
    FormAccount,
    TableManagerBottom
  },
  data () {
    return {
      options: {
        isShowAddButton: false
      },
      accountId: null,
      userId: null,
      filter: null,
      perPage: 20,
      totalRows: 0,
      currentPage: 1,
      currentRow: null,
      editUserInfo: null
    }
  },
  methods: {
    refreshTable () {
      this.$refs.Accounts.load()
      this.$emit('refreshTable')
    },
    makeToasts (variant, body, title) {
      this.$root.$emit('makeToasts', variant, body, title)
    },
    closeAccount () {
      this.editCurrentRow = JSON.parse(JSON.stringify(this.currentRow))
      this.currentRow = null
      this.$refs.Accounts.load()
    },
    filterChanged (value) {
      this.filter = value
    },
    paginationChanged (value) {
      this.perPage = value
    },
    closePayment () {
      this.$refs.refPayment.hide()
    },
    ClickOnPaymentButton (row) {
      this.accountId = row.account_id
      this.userId = row.user_id
      this.$refs.refPayment.show()
    },
    openFullAccountInfo (row) {
      this.currentRow = row
      this.accountId = row.account_id
      this.userId = row.user_id
    }
  },
  watch: {
    currentRow: function (val) {
      this.editCurrentRow = JSON.parse(JSON.stringify(val))
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/users/accounts/main.vue